import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AjouteReservationDirect = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/ajouteReservationDirect`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


export { AjouteReservationDirect }